import { render, staticRenderFns } from "./NewScheduleForm.vue?vue&type=template&id=053d7166&scoped=true"
import script from "./NewScheduleForm.vue?vue&type=script&lang=js"
export * from "./NewScheduleForm.vue?vue&type=script&lang=js"
import style0 from "./NewScheduleForm.vue?vue&type=style&index=0&id=053d7166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d7166",
  null
  
)

export default component.exports